/*
GPS DataViz

Copyright © 2021 GPSDataViz

Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
*/

import React from "react";
import { Button, Divider } from 'antd';
import '../../Styles/styles-Features.css';
import { OnBoardingNav } from "../Navigation/OnBoardingNav";

import {getTeamData,getPlayerData,getBreakdownData,getBaselineData,getCompareData, getDrillData} from './fakeData.js';

//char imports
import { TeamAvgTable } from "../Team/TeamAvgTable";
import BreakdownCharts from "../Breakdown/BreakdownCharts";
import { BaselineChart } from "../Baseline/BaselineChart";
import { PlayerCharts } from "../Player/PlayerCharts";
import { ComparisonChart } from "../Compare/ComparisonChart";
import { DrillCharts } from '../Drills/DrillCharts';



function onChange(a, b, c) {
    console.log(a, b, c);
  }


  export class Features extends React.Component{
    state = {
        username:"",
        password: "",
        error: "",
        logged_in: false,
        team_data: getTeamData(),
        player_data: getPlayerData(),
        breakdown_data:getBreakdownData(),
        baseline_data:getBaselineData(),
        compare_data:getCompareData(),
        drill_data:getDrillData(),
    }; 

    
    render(){
        return <>
            <div>
                <OnBoardingNav />
                <div className="features-item first-feature-item">
                    <div className="features-divider">
                    <p className="features-title">Automated Reporting</p>
                    <div className="chart-description">
                    Our automated system generates an email to the coaching staff as soon as the team is done training telling them:
                    <ul className="features-list">
                        <li className="features-elements features-top-element">What you did today at training</li>
                        <li className="features-elements">What you need to do tomorrow at training</li>
                        <li className="features-elements">Which players are overworked</li>
                        <li className="features-elements">Which players are underperforming</li>
                        <li className="features-elements">Who is getting faster</li>
                    </ul>
                    </div>
                    </div>
                    <div className="search-divider"><Divider></Divider></div>
                </div>
                <div className="features-item">
                    <div className="features-divider">
                    <p className="features-title">Team Charts</p>
                    <p className="chart-description">While the main landing page shows coaches a calendar where they see the team averages from each session, the "TEAM" page allows them to drill down into each day's individual data. They can sort sessions by metric and view Acute to Chronic Workload Ratios (ACWR) of team averages in key metrics over time.</p>
                    </div>
                    <TeamAvgTable dataIn={this.state.team_data} player_data={false} home_page={true} />
                    <div className="search-divider"><Divider></Divider></div>
                </div>
                <div className="features-item">
                <div className="features-divider">
                    <p className="features-title">Player Charts</p>
                    <p className="chart-description">The "PLAYER" page shows all of a player's data as well as their injury history.  Each chart is color-coded based on the player's game baseline with ACWR of key metrics making it easy to see where a player is in their development and how best to train them going forward.</p>
                    </div>
                    <PlayerCharts dataIn={this.state.player_data} player_data={false} home_page={true} />
                    <div className="search-divider"><Divider></Divider></div>
                </div>
                <div className="features-item">
                <div className="features-divider">
                    <p className="features-title">Breakdown Charts</p>
                    <p className="chart-description">The "BREAKDOWN" page allows coaches to view each player's external and internal load from any individual training session or game.  Coaches can sort player outputs by metric and easily see how different players performed in the day's session.</p>
                    </div>
                    <BreakdownCharts dataIn={this.state.breakdown_data.table_data} player_load_data_in={this.state.breakdown_data.player_load_data} distance_data_in={this.state.breakdown_data.distance_data} colors_100={this.state.breakdown_data.colors} sprint_distance_data_in={this.state.breakdown_data.sprint_distance_data} top_speed_data_in={this.state.breakdown_data.top_speed_data} pagination={this.state.pagination} player_data={this.state.breakdown_data.player_name} home_page={true}/>
                    <div className="search-divider"><Divider></Divider></div>
                </div>
                {/* <div className="features-item">
                <div className="features-divider">
                    <p className="features-title">Baseline Charts</p>
                    <p className="chart-description">GPS DataViz has custom templates but we prefer to use your historical data to baseline players by position according to your game model, making your tactics dictate the external loads needed from each player.  These individual player baselines allow you to view training data in the context of what a player’s game day demands will be.  You can view each player’s output at training as a percentage of their game baselines, and every piece of data you see on a player will always be color coded based on their individual baseline.  This allows you to build towards the specific goal of training players for their individual game demands.</p>
                    </div>
                    <BaselineChart dataIn={this.state.baseline_data} player_data={false} home_page={true}/>
                    <div className="search-divider"><Divider></Divider></div>
                </div> */}
                {/* <div className="features-item">
                <div className="features-divider">
                    <p className="features-title">Drill Charts</p>
                    <p className="chart-description">The "DRILLS" page allows coaches who segment data during training to view outputs from a specific drill they did on a certain day as well as compare the same drill performed on different days and how the external loads varied, both overall and per minute.</p>
                    </div>
                    <DrillCharts dataIn={this.state.drill_data} individual={true} home_page={true}/>
                    <div className="search-divider"><Divider></Divider></div>
                </div> */}
                <div className="features-item last-feature-item">
                <div className="features-divider">
                    <p className="features-title">Comparison Charts</p>
                    <p className="chart-description">The "COMPARE" page is designed for coaches to compare their top outputs in each key metric from their prior games, easily allowing them to compare games and adjust their tactics for games depending on their players' physical readiness.  Team averages can be deceiving on game days as home and away roster sizes vary and averaging players who didn't see the field during the game can heavily skew the data.</p>
                    </div>
                    <ComparisonChart dataIn={this.state.compare_data.data} num_games_compared={this.state.compare_data.num_games} home_page={true}/>
                    <div className="search-divider"><Divider></Divider></div>
                </div>
            </div>
        </>
    }
}


